import { MagicLinkForm } from '@/components/auth';

/**
 * Magic Link Page
 * Displays the magic link request form
 */
export default function MagicLinkPage() {
  return <MagicLinkForm />;
}
